/**
 * Every usage endpoint path, in one place.
 *
 * These are declared here rather than inline at the call sites for one reason:
 * `apiClient.baseURL` is the bare origin (`VITE_API_BASE_URL`), while the API
 * mounts everything under a global `api` prefix (`main.ts` → `setGlobalPrefix`).
 * So each path must carry `api/` itself, and omitting it produces a 404 that no
 * type is able to catch — the integration harness boots the Nest app WITHOUT
 * the global prefix, so a server-side spec cannot catch it either.
 *
 * Collecting them makes the whole client-side surface assertable in one spec
 * (`admin-usage-endpoints.spec.ts`) and diffable by eye against the route table
 * in `admin-usage.controller.ts`.
 *
 * No leading slash, matching `admin-api.ts`.
 */
export const usageEndpoints = {
  overview: () => 'api/admin/usage/overview',
  tenants: () => 'api/admin/usage/tenants',
  tenantUsage: (tenantId: string) => `api/admin/tenants/${tenantId}/usage`,
} as const;
